import React, { useState } from "react";

// libarry and framework
import _ from "lodash";
import { Button, Spinner } from "react-bootstrap";
import { useMutation } from "@apollo/client";
import { useToasts } from "react-toast-notifications";

//component
import { JOINT_ORDER_GROUP } from "../../../graphql/orderGroup/mutation";
import ModalConfirmComponent from "../../ModalConfirmComponent";

// icons 
import {
    MdCached,
} from "react-icons/md";

function BtnJointCfOrderGroup({ setIsFetch,orderGroupSelect, setIsSelectAll, setOrderGroupDownload, setSelectedIds}) {
    const { addToast } = useToasts();
    const [isConfirm, setIsConfirm] = useState(false)
    // TODO CALL API JOINT_ORDER
    const [jointOrder, { loading: jointOrderGroupLoading }] = useMutation(JOINT_ORDER_GROUP);

    const validateJointOrderGroup = async ({ orderGroups }) => {
        try {
            if (jointOrderGroupLoading) return;
            const errorMessage = "ບໍ່ສາມາດລວມອໍໄດ້ ກະລຸນາກວດສອບ ແລະ ແລ້ວລອງໃຫມ່ອີກຄັ້ງ ຫລື ຕີດຕໍ່ call center";
            // get shop
            let SHOP_ID = await localStorage.getItem("SHOP");
            if (_.isEmpty(SHOP_ID)) throw `IS_EMPTY_SHOP: ${errorMessage}`;

            // set user facebook id
            const userFbIdDefault = orderGroups[0].userFbId;
            if (_.isEmpty(userFbIdDefault)) throw `INVALID_USER_FACEBOOK_ID: ${errorMessage}`;

            // set type
            const typeDefault = orderGroups[0].type;
            if (_.isEmpty(typeDefault)) throw `IS_EMPTY_TYPE: ${errorMessage}`;

            // set live or post id
            const liveOrPostIdDefault = typeDefault === "LIVE" ? orderGroups[0].live?.id : typeDefault === "POST" ? orderGroups[0].post?.id : '';
            if (_.isEmpty(liveOrPostIdDefault)) throw `IS_EMPTY_LIVE_OR_POST_ID: ${errorMessage}`;

            // loop order
            let ids = [];
            let status;
            let type;
            let liveOrPostId;
            let userFbId;
            for (const orderGroup of orderGroups) {
                if (_.isEmpty(orderGroup.id)) throw `INVALID_ORDER_ID: ${errorMessage}`;
                // check status
                if (orderGroup?.status !== "CREATED" || _.isEmpty(orderGroup?.status)) throw `INVALID_STATUS: ${errorMessage}`;
                // check type
                if (!["LIVE", "POST"].includes(orderGroup?.type) || typeDefault !== orderGroup?.type) throw `INVALID_POST/LIVE: ${errorMessage}`;
                // check user facebook id
                if (orderGroup?.userFbId !== userFbIdDefault) throw `INVALID_USER_FB: ${errorMessage}`;
                // check post/live id
                const newLiveOrPost = typeDefault === "LIVE" ? orderGroup?.live?.id : typeDefault === "POST" ? orderGroup?.post?.id : '';
                if (newLiveOrPost !== liveOrPostIdDefault) throw `INVALID_POST_OR_LIVE: ${errorMessage}`;

                // data request
                ids.push(orderGroup?.id);
                status = orderGroup?.status;
                type = orderGroup?.type;
                liveOrPostId = typeDefault === "LIVE" ? orderGroup?.live?.id : typeDefault === "POST" ? orderGroup?.post?.id : '';
                userFbId = orderGroup?.userFbId;
            };

            const _variables = {
                variables: {
                    where: {
                        id: ids,
                        shop: SHOP_ID,
                        status: status,
                        type: type,
                        liveOrPostId: liveOrPostId,
                        userFbId: userFbId
                    },
                },
            };
            // TODO: call api joint order
            const response = await jointOrder(_variables);
            if (_.isEmpty(response?.error)) {
                addToast("ລວມອໍເດີ ສຳເລັດ", {
                    appearance: "success",
                    autoDismiss: true,
                    timer: 3000,
                });
            setIsConfirm(false)
            setIsFetch(true)
            setIsSelectAll(false);
            setOrderGroupDownload([]);
            setSelectedIds([]);

            } else {
                addToast("ລວມອໍເດີ ຫລົ້ມເຫລວ!!", {
                    appearance: "error",
                    autoDismiss: true,
                    timer: 3000,
                });
            }
        } catch (error) {
            // console.log("joint order failed error: ", error);
            addToast("ລວມອໍເດີ ຫລົ້ມເຫລວ!", {
                appearance: "warning",
                autoDismiss: true,
            });
            setIsConfirm(false)
        }
    }
    return (
        <>

            <Button
                variant="light"

                disabled={
                    orderGroupSelect && orderGroupSelect.length > 1
                        ? false
                        : true
                }
                onClick={() => {
                    if (orderGroupSelect.length <= 1) {
                        addToast("ກະລຸນາເລືອກອໍເດີ້ໃດຫນຶ່ງກ່ອນ!", {
                            appearance: "warning",
                            autoDismiss: true,
                        });
                        return;
                    };
                    setIsConfirm(true)
                }}
                style={{
                    display: 'flex', justifyContent: 'start', alignItems: 'center',width:'100%'
                }}
            >
                {
                    jointOrderGroupLoading ? (<Spinner animation="border" size="sm" />
                    ) : (
                        <MdCached />
                    )
                }
                &nbsp; ລວມອໍເດີ(cf)
            </Button>

            <ModalConfirmComponent
                showConfirmModal={isConfirm}
                handleCancel={() => setIsConfirm(false)}
                handleConfirm={() => validateJointOrderGroup({ orderGroups: orderGroupSelect })}
                loadingConfirm={jointOrderGroupLoading}
                title="ແຈ້ງເຕືອນ"
                text={"ທ່ານຕ້ອງການລວມອໍເດິ້ນີ້ແທ້ບໍ່!"}
            />


        </>


    );
}

export default BtnJointCfOrderGroup;
